import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateInstitution, updateOnboardingStatus } from "../../pages/Settings/CompanyProfile/institutionThunk";
import SpotlightOverlay from "./SpotlightOverlay";
import { selectAuthInfo } from "../../pages/Auth/authSelectors";
import { isHrmsOnlySubscription } from "../../utils/accessChecker";

const financeStep = {
  key: "finance",
  title: "Finance",
  description: "Set your VatNo/GSTIN, Trade License No & Expiry, Financial Year.",
  section: "finance",
};

const infoStep = {
  key: "info",
  title: "Info",
  description: "Set your company Email, Phone, Website and Timezone.",
  section: "info",
};

const hrStep = {
  key: "hr",
  title: "HR Setup",
  description: "Configure Leave Type, No. of Leaves, Weekends, etc.",
  section: "hr",
};

const billStep = {
  key: "bill",
  title: "Billing",
  description: "Set Return Policy, Company Logo, Stamp, Signature to use in invoices.",
  section: "bill",
};

// HRPayroll-only subscriptions have no VAT/trade-license (Finance) or
// invoice/quotation (Billing) modules at all, so those two steps would just
// point the admin at settings that don't apply to their plan — HRMS-only
// accounts get a shorter, HR-relevant-only tour instead.
const allSteps = [financeStep, infoStep, hrStep, billStep];
const hrmsOnlySteps = [infoStep, hrStep];

const stepTargetMap = {
  finance: '[data-onboard="finance"]',
  info: '[data-onboard="info"]',
  hr: '[data-onboard="hr"]',
  bill: '[data-onboard="bill"]',
};

const OnboardingWizard = ({ visible, onClose, triggerEdit, setCurrentStepKey, step, setStep, }) => {
  const dispatch = useDispatch();
  const authInfo = useSelector(selectAuthInfo);
  const steps = isHrmsOnlySubscription(authInfo?.subscription) ? hrmsOnlySteps : allSteps;

  useEffect(() => {
    if (!visible) return;
    const current = steps[step];
    if (!current) return;
    // delay to avoid race condition after save
    const timer = setTimeout(() => {
      triggerEdit(current.section);
    }, 100);
    return () => clearTimeout(timer);
  }, [step, visible]);

  

  useEffect(() => {
    const handleSave = async () => {
      console.log("✅ onboarding-save triggered");

      const isLastStep = step >= steps.length - 1;

      if (isLastStep) {
        await updateStatus("completed");
        onClose();
        return;
      }

      setStep((prev) => prev + 1);
    };

    window.addEventListener("onboarding-save", handleSave);

    return () => {
      window.removeEventListener("onboarding-save", handleSave);
    };
  }, [step]);

  // useEffect(() => {
  //   const finish = async () => {
  //     if (step >= steps.length) {
  //       await updateStatus("completed");
  //       onClose();
  //     }
  //   };

  //   finish();
  // }, [step]);

    useEffect(() => {
  if (visible) {
    setCurrentStepKey(steps[step]?.key);
  }
}, [step, visible]);

  if (!visible) return null;

  const currentStep = steps[step];

  

  const updateStatus = async (status) => {
    await dispatch(updateOnboardingStatus(status));
  };
  

// ✅ COMPLETION STATE
if (step >= steps.length) {
  return (
    <div style={styles.container}>
      <h3>You're all set 🎉</h3>
      <p>Your initial company setup is complete.</p>

      <Button
        type="primary"
        onClick={onClose}
        style={{ marginTop: 10 }}
      >
        Finish
      </Button>
    </div>
  );
}

// ✅ NORMAL STEP FLOW
return (
  <div style={styles.container}>
    {/* <SpotlightOverlay
      targetSelector={stepTargetMap[currentStep?.key]}
    /> */}

    <h3>{currentStep.title}</h3>
    <p>{currentStep.description}</p>

    <p>
      {/* Click the <b>Edit (✏️)</b> button in the highlighted section to update this setting. */}
      Click the <b>Okay</b> button in the highlighted section to update this setting after updating the fields you want.
    </p>

    {step !== steps.length - 1 && (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <Button
          type="primary"
          onClick={() => setStep((s) => s + 1)}
        >
          Next
        </Button>

        <Button
        onClick={() => {
          const currentStatus = authInfo?.onboarding_status;

          if (currentStatus === "skipped_once") {
            // 👉 second time skip → disable permanently
            updateStatus("disabled");
            onClose();
            return;
          }

          // 👉 first time skip
          updateStatus("skipped_once");
          onClose();
          // setStep((s) => s + 1);
        }}
      >
        Skip Now
      </Button>

        <Button
          onClick={() => {
            updateStatus("disabled");
            onClose();
          }}
        >
          Skip & Don’t Show Again
        </Button>
      </div>
    )}

    <div style={{ marginBottom: 10 }}>
      <strong>
        Step {step + 1} of {steps.length}
      </strong>

      <div
        style={{
          height: 6,
          background: "#eee",
          borderRadius: 4,
          marginTop: 6,
        }}
      >
        <div
          style={{
            width: `${((step + 1) / steps.length) * 100}%`,
            height: "100%",
            background: "#1677ff",
            borderRadius: 4,
            transition: "0.3s",
          }}
        />
      </div>
    </div>
  </div>
);
};

const styles = {
  container: {
    position: "fixed",
    bottom: 85,
    right: 20,
    width: 300,
    background: "#fff",
    padding: 16,
    borderRadius: 10,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    zIndex: 1010,
  },
};

export default OnboardingWizard;